<app-loading *ngIf="isLoading"></app-loading>
<div class="m-4">
  <div class="row px-3">
    <div class="col-12">
      <p class="titleFont">
        {{ "label.claim.claimDetails.activitiesOfDailyLiving" | translate }}
      </p>
    </div>
  </div>
  <div class="card px-3 py-4">
    <div class="row mb-2">
      <div class="col-8">
        <p class="purpleTitle ml-2">
          {{ "label.claim.claimDetails.listOfActivities" | translate }}
        </p>
      </div>
      <div class="col-4 text-left">
        <p class="purpleTitle">
          {{ "label.claim.claimDetails.dateOfOnset" | translate }}
        </p>
      </div>
    </div>
    <div
      class="row contentList"
      *ngFor="let item of disabilityLevelList; index as i"
    >
      <div class="col-8 d-flex">
        <dxc-checkbox
          [checked]="dailyLivingDetails[i].isSelected"
          (onChange)="onDataInput($event, 'isSelected', i)"
          [value]="dailyLivingDetails[i].isSelected"
          [disabled]="true"
        ></dxc-checkbox>
        <p class="ml-3">
          {{ item.label }}
        </p>
      </div>
      <div class="col-4" *ngIf="i != disabilityLevelList.length - 1">
        <custom-date-picker
          digitDate
          margi="xxsmall"
          (valueChange)="onDataInput($event, 'activityDate', i)"
          [model]="dailyLivingDetails[i].activityDate"
          [errorMessage]="getErrorMessage('activityDate')"
          [placeholder]="true"
          [required]="true"
          [disabled]="true"
        ></custom-date-picker>
      </div>
    </div>
  </div>
  <div class="row endButtons">
    <custom-button
      class="saveBtn"
      label="{{ 'processClaims.decisionAndSettlement.save' | translate }}"
      mode="primary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
    <custom-button
      class="cancelBtn"
      label="{{ 'processClaims.decisionAndSettlement.cancel' | translate }}"
      mode="secondary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
  </div>
</div>
